module.exports = __webpack_public_path__ + "static/media/instagram.c7632ed1.png";